module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar",
    class: {
      'navbar-transparent': _vm.isTrans
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowbar),
      expression: "isShowbar"
    }],
    staticClass: "nav-left"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('div', {
    staticClass: "ifree-logo"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.logo,
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.navToggle
    }
  }, [_c('Icon', {
    attrs: {
      "type": "navicon"
    }
  })], 1)]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNav),
      expression: "isNav"
    }],
    staticClass: "nav nav-default",
    class: {
      active: _vm.navStatus
    }
  }, _vm._l((_vm.menu), function(item, index) {
    return _c('li', {
      class: {
        active: item.to.name == _vm.activeTo
      },
      on: {
        "mouseover": function($event) {
          _vm.ThisShow(index)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": item.to
      },
      nativeOn: {
        "click": function($event) {
          _vm.menuToggle(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "nav-right",
    class: {
      active: _vm.navStatus
    }
  }, [_c('ul', {
    staticClass: "nav nav-default nav-no-hover"
  }, [_c('span', {
    staticClass: "search_bar"
  }, [_c('li', {
    staticClass: "nav-search",
    class: {
      active: _vm.searchStatus
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticStyle: {
      "padding": "0",
      "font-size": "24px",
      "line-height": "32px"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('enter_keyword')
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.search($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isClose),
      expression: "isClose"
    }],
    staticClass: "close_search"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.close_search
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/home/icon-close.png")
    }
  })])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowbar),
      expression: "isShowbar"
    }],
    staticStyle: {
      "display": "flex"
    }
  }, [_c('li', {
    staticClass: "search-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.searchToggle
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.searchBtn,
      "width": "20"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "shopping"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.shopping
    }
  }, [_c('img', {
    staticClass: "shopping-cart",
    attrs: {
      "src": _vm.shoppingCart,
      "width": "20"
    }
  }), _vm._v(" "), _c('sup', {
    style: ({
      display: _vm.cartCount === 0 ? 'none' : 'inline'
    })
  }, [_vm._v(_vm._s(_vm.cartCount))])])]), _vm._v(" "), (!_vm.isLogin) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.modal1 = true
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.loginThis
    }
  }, [_c('img', {
    staticClass: "my-user",
    attrs: {
      "src": _vm.myUser,
      "width": "20"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.showUserMenu
    }
  }, [_c('img', {
    staticClass: "my-user",
    attrs: {
      "src": _vm.myUser,
      "width": "20"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-user",
    class: {
      active: _vm.showMenuStatus
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.nickname))])])]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Personal'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('personal_center')))])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'iPoint'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('top_up')))])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'app'
      }
    }
  }, [_c('span', [_vm._v("iAPP")])])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('sign_out')))])])])])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "mobile-shopping"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ShoppingCart'
      }
    }
  }, [_c('img', {
    staticClass: "shopping-cart",
    attrs: {
      "src": require("../../assets/shopping_cart_black.png"),
      "width": "20"
    }
  }), _vm._v(" "), _c('sup', {
    style: ({
      display: _vm.cartCount === 0 ? 'none' : 'inline'
    })
  }, [_vm._v(_vm._s(_vm.cartCount))])])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.dropdownToggle
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.defaultLanguage.flag,
      "width": "30"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.defaultLanguage.value))]), _vm._v(" "), _c('img', {
    staticClass: "unfold",
    attrs: {
      "src": _vm.unfold,
      "width": "10"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    class: {
      active: _vm.dropdownStatus
    }
  }, _vm._l((_vm.language), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.toggleLanguage(item.label)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_c('img', {
      attrs: {
        "src": item.flag,
        "width": "30"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.value))])])])
  }))])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ConectShow),
      expression: "ConectShow"
    }],
    staticClass: "nav-Conect",
    on: {
      "mouseleave": function($event) {
        _vm.ConectHide()
      }
    }
  }, [_c('div', {
    staticClass: "nav-Conect-wrap"
  }, [_c('ol', _vm._l((_vm.submenulist), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('router-link', {
      attrs: {
        "to": item.to
      },
      nativeOn: {
        "click": function($event) {
          _vm.submenuToggle(index)
        }
      }
    }, [_c('img', {
      staticClass: "grey-icon",
      attrs: {
        "src": item.grey,
        "width": "56"
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "blue-icon",
      attrs: {
        "src": item.blue,
        "width": "56"
      }
    }), _vm._v(" "), _c('p', [_vm._v("\n                                " + _vm._s(item.name) + "\n                            ")])])], 1)
  }))])])]), _vm._v(" "), _c('modal', {
    staticClass: "bind_email",
    attrs: {
      "size": "small"
    },
    on: {
      "on-ok": _vm.fb_bind_email
    },
    model: {
      value: (_vm.bind_email),
      callback: function($$v) {
        _vm.bind_email = $$v
      },
      expression: "bind_email"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "bind_email_title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('bind_email_title')))])]), _vm._v(" "), _c('div', {
    staticClass: "bind_email_sm-title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('bind_email_modal_tips')))])]), _vm._v(" "), _c('div', {
    staticClass: "bind_email_input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bind_email_email),
      expression: "bind_email_email"
    }],
    attrs: {
      "type": "email",
      "name": "forget psw email",
      "placeholder": _vm.$t('user_center_email')
    },
    domProps: {
      "value": (_vm.bind_email_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bind_email_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bind_email_input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bind_email_psw),
      expression: "bind_email_psw"
    }],
    attrs: {
      "type": "password",
      "name": "forget psw email",
      "placeholder": _vm.$t('user_center_password')
    },
    domProps: {
      "value": (_vm.bind_email_psw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bind_email_psw = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bind_email_determine"
  }, [_c('button', {
    on: {
      "click": _vm.fb_bind_email
    }
  }, [_vm._v(_vm._s(_vm.$t('determine_btn')))])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })]), _vm._v(" "), _c('modal', {
    staticClass: "forget_password",
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.forget_moadl),
      callback: function($$v) {
        _vm.forget_moadl = $$v
      },
      expression: "forget_moadl"
    }
  }, [(_vm.spinShow_forget) ? _c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "forget_password-title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('user_center_retrieve_password')))])]), _vm._v(" "), _c('div', {
    staticClass: "forget_password-sm-title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('user_center_forget_password_sub_title')))])]), _vm._v(" "), _c('div', {
    staticClass: "forget_password-main"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forget_psw_email),
      expression: "forget_psw_email"
    }],
    attrs: {
      "type": "email",
      "name": "forget psw email",
      "placeholder": _vm.$t('user_center_email')
    },
    domProps: {
      "value": (_vm.forget_psw_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.forget_psw_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "forget_password-nex-btn"
  }, [_c('button', {
    on: {
      "click": _vm.forget_password_next
    }
  }, [_vm._v(_vm._s(_vm.$t('next')))])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1), _vm._v(" "), _c('modal', {
    staticClass: "TouristLogin",
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.TouristLogin),
      callback: function($$v) {
        _vm.TouristLogin = $$v
      },
      expression: "TouristLogin"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h1', {
    staticClass: "font_big TouristLogin_title"
  }, [_vm._v(_vm._s(_vm.$t('tourist_title')))]), _vm._v(" "), _c('Row', [_c('i-col', {
    staticClass: "TouristLogin_login",
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [(this.TouristShow == true) ? _c('div', {
    staticClass: "TouristLogin_loginwrap"
  }, [_c('h2', {
    staticClass: "font_mid"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('tourist_member')) + "\n                        ")]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "TouristLogin_email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.touristName),
      expression: "touristName"
    }],
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": _vm.$t('user_center_email')
    },
    domProps: {
      "value": (_vm.touristName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.touristName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "TouristLogin_password",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.touristPassword),
      expression: "touristPassword"
    }],
    staticClass: "Touristpassword_1",
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": _vm.$t('user_center_password')
    },
    domProps: {
      "value": (_vm.touristPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.touristPassword = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.showthis_1 === 'a') ? _c('img', {
    staticStyle: {
      "position": "absolute",
      "right": "5px",
      "top": "15px"
    },
    attrs: {
      "src": require("../../assets/icon_eye.png"),
      "width": "30"
    },
    on: {
      "click": function($event) {
        _vm.hide()
      }
    }
  }) : (_vm.showthis_1 === 'b') ? _c('img', {
    staticStyle: {
      "position": "absolute",
      "right": "5px",
      "top": "15px"
    },
    attrs: {
      "src": require("../../assets/icon_hide.png"),
      "width": "30"
    },
    on: {
      "click": function($event) {
        _vm.show()
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('a', {
    staticClass: "font_mid forget",
    on: {
      "click": _vm.forget_psw
    }
  }, [_vm._v(_vm._s(_vm.$t('user_center_forget_password')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', {
    staticStyle: {
      "font-size": "14px",
      "color": "#5E6D82",
      "text-align": "left",
      "margin-top": "10px"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('login_agree')) + "\n                                "), _c('router-link', {
    staticClass: "text-primary",
    attrs: {
      "to": {
        name: 'terms_of_service'
      }
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('agree_terms_of_conditions')) + "\n                                ")]), _vm._v("\n                                ,\n                                "), _c('router-link', {
    staticClass: "text-primary",
    attrs: {
      "to": {
        name: 'privacy_policy'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('agree_privacy_policy')) + "\n                                ")]), _vm._v("\n                                " + _vm._s(_vm.$t('and')) + "\n                                "), _c('router-link', {
    staticClass: "text-primary",
    attrs: {
      "to": {
        name: 'terms_of_law'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('agree_terms_of_law')) + "\n                                ")]), _vm._v("\n                                .\n                            ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "TouristLogin_btn"
  }, [_c('button', {
    on: {
      "click": _vm.login
    }
  }, [_vm._v(_vm._s(_vm.$t('tourist_member')))])]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('a', [_c('p', {
    staticClass: "font-small",
    staticStyle: {
      "text-align": "center"
    },
    on: {
      "click": _vm.changeLogin
    }
  }, [_vm._v(_vm._s(_vm.$t('login_tip')))])])])]) : _c('div', {
    staticClass: "TouristLogin_loginwrap"
  }, [_c('h2', {
    staticClass: "font_mid"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('tourist_member')) + "\n                        ")]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "TouristLogin_name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.touristRisgterName),
      expression: "touristRisgterName"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('user_center_username')
    },
    domProps: {
      "value": (_vm.touristRisgterName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.touristRisgterName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "TouristLogin_email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.touristRisgteremail),
      expression: "touristRisgteremail"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('user_center_email')
    },
    domProps: {
      "value": (_vm.touristRisgteremail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.touristRisgteremail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "TouristLogin_password",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.touristRisgterePsw),
      expression: "touristRisgterePsw"
    }],
    staticClass: "Touristpassword_1",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('user_center_password')
    },
    domProps: {
      "value": (_vm.touristRisgterePsw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.touristRisgterePsw = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.showthis_1 === 'a') ? _c('img', {
    staticStyle: {
      "position": "absolute",
      "right": "5px",
      "top": "15px"
    },
    attrs: {
      "src": require("../../assets/icon_eye.png"),
      "width": "30"
    },
    on: {
      "click": function($event) {
        _vm.hide()
      }
    }
  }) : (_vm.showthis_1 === 'b') ? _c('img', {
    staticStyle: {
      "position": "absolute",
      "right": "5px",
      "top": "15px"
    },
    attrs: {
      "src": require("../../assets/icon_hide.png"),
      "width": "30"
    },
    on: {
      "click": function($event) {
        _vm.show()
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', {
    staticStyle: {
      "font-size": "14px",
      "color": "#5E6D82",
      "text-align": "left"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('login_agree')) + "\n                                "), _c('router-link', {
    staticClass: "text-primary",
    attrs: {
      "to": {
        name: 'terms_of_service'
      }
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('agree_terms_of_conditions')) + "\n                                ")]), _vm._v("\n                                ,\n                                "), _c('router-link', {
    staticClass: "text-primary",
    attrs: {
      "to": {
        name: 'privacy_policy'
      }
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('agree_privacy_policy')) + "\n                                ")]), _vm._v("\n                                " + _vm._s(_vm.$t('and')) + "\n                                "), _c('router-link', {
    staticClass: "text-primary",
    attrs: {
      "to": {
        name: 'terms_of_law'
      }
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('agree_terms_of_law')) + "\n                                ")]), _vm._v("\n                                .\n                            ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "TouristLogin_btn"
  }, [_c('button', {
    on: {
      "click": _vm.registerUser
    }
  }, [_vm._v(_vm._s(_vm.$t('tourist_member')))])])])]), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('div', {
    staticClass: "TouristLogin_loginwrap TouristLogin_hide"
  }, [_c('h2', {
    staticClass: "font_mid"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('tourist_guest')) + "\n                        ")]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('tourist_guest_tile')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "TouristLogin_join"
  }, [_c('h2', {
    staticClass: "font_mid"
  }, [_vm._v(_vm._s(_vm.$t('tourist_guest_content1')))]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v(_vm._s(_vm.$t('tourist_guest_content2')))]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v(_vm._s(_vm.$t('tourist_guest_content3')))]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v(_vm._s(_vm.$t('tourist_guest_content4')))]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v(_vm._s(_vm.$t('tourist_guest_content5')))])]), _vm._v(" "), _c('div', {
    staticClass: "TouristLogin_btn2"
  }, [_c('router-link', {
    staticClass: "text-primary",
    attrs: {
      "to": {
        name: 'Confirmation'
      }
    }
  }, [_c('button', [_vm._v(_vm._s(_vm.$t('tourist_guest')))])])], 1)])])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc21730e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/Navbar.vue
// module id = 844
// module chunks = 0